import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, useColorModeValue } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tabsAnatomy.keys
);

const baseStyle = definePartsStyle(props => {
  const bgColor = useColorModeValue('#FFF', '#1A1A1A');
  const activeBgColor = useColorModeValue('#DFD7F7', '#3B315B');

  return {
    tab: {
      bg: bgColor,
      padding: '12px 24px',
      borderRadius: '16px',
      color: mode('neutral.on.surface.1', 'neutral.element.primary')(props),
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '24px',
      _selected: {
        bg: activeBgColor,
        color: mode('neutral.on.surface.1', 'neutral.element.primary')(props),
      },
      _hover: {
        bg: activeBgColor,
        color: mode('neutral.on.surface.1', 'neutral.element.primary')(props),
      },
      _active: {
        bg: activeBgColor,
        color: mode('neutral.on.surface.1', 'neutral.element.primary')(props),
      },
    },
    tablist: {
      gap: '16px',
    },
    tabpanel: {
      // pt: '16px',
    },
  };
});

const sizes = {
  md: definePartsStyle({
    tab: {
      fontSize: 'md',
      py: '12px',
      px: '16px',
    },
  }),
};

// Custom variant for the platform
const variants = {
  primary: baseStyle,
};

export const tabsTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
});
